<template>
	<div class="form-group clearfix">
		<div
			:class="{'float-left': (field.labelStyle=='justify'||field.labelStyle=='inline')}"
		>
			<label v-if="field.question" class="mr-2 align-top" :for="field.id">
				{{ field.question }}
				<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
			</label>
            <small 
                v-if="requiredIncomplete"
                class="ml-1" style="color:#FF0000"    
            >
                {{  $t('required')}}
            </small>
			<div v-if="field.description" v-html="field.description" class="mr-2"></div>
			<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
		</div>
		<div :class="{'float-right': (field.labelStyle=='justify')}" v-bind:style="{ 'display': (field.labelStyle=='justify'||field.labelStyle=='inline'?'inline':'') }">

			<select
				v-if="(field.selectType && field.selectType == 'dropdown')"
				:disabled="readonly"
				v-model="field.value"
				class="form-control"
                :class="{'requiredincomplete': requiredIncomplete}"
				:id="field.id"
			>
				<option value="">{{$t('please-select')}}</option>
				<option
				v-for="(option, okey) in options"
				:key="okey"
				:value="option.value"
				:aria-label="`${field.question}: ${option.caption}`"
				>{{ option.caption }}</option>
			</select>

			<div
				class="btn-group"
				v-else
				:id="field.id"
			>
				<button
				v-for="(option, okey) in options"
				:key="okey"
				class="btn"
				:class="getClassStr(option)"
				@click="toggleValue(option)"
				:disabled="readonly"
				:aria-label="`${field.question}: ${option.caption}`"
				:viewinfo="viewinfo"
				>
					<span>{{ option.caption }}</span>
					<span v-if="(viewinfo && option.info)" class="text-sm"><br><span v-html="option.info"></span></span>
				</button>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly','viewAs'],
	data() {
		return {
			'viewinfo': false
		}
	},
	methods: {
		toggleValue(option){
			if(this.field.value.includes(option.value)) {
				this.field.value.splice(this.field.value.indexOf(option.value), 1);
			} else {
				this.field.value.push(option.value);
			}
		},
        getClassStr(option) {
			const classArr = [''];
			if(this.field.value.includes(option.value)) {
				if(this.field.cssclass) {
					classArr.push(`btn-on ${this.field.cssclass}`);
				} else {
					classArr.push('btn-on');
				}
			} else {
				classArr.push('btn-off');
			}
			if(this.readonly) {
				classArr.push('disabled');
			}
            if(this.requiredIncomplete) classArr.push('requiredincomplete');
			return classArr.join(' ');
		},
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        }
	},
	computed: {
		options() {
			if(this.field.optionsFromConfig) {
				const options = [];
				for(let option of this.$config.getValue(this.field.optionsFromConfig)) {
					options.push({
						value: option.id,
						caption: option.name
					})
				}
				return options;
			} else {
				return this.field.options;
			}
		},
        requiredIncomplete() {
            return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0) 
            && this.field.required && this.field.value.length == 0;
        },
        hasInfo() {
        	if(this.field.info) return true;
			for(let option of this.field.options) {
				if(option.info) return true;
			}
        	return false;
        }
	}
};
</script>
